// import toastMessage from "../../Components/Helper/toast";

// export const fetchFun = async (fetchUrl, method = "GET", body = null, errMsg = "An error occurred") => {
//     const userSession = JSON.parse(localStorage.getItem("userSession"));
    
//     try {
//         const myHeaders = new Headers({ "Content-Type": "application/json", "X-Access-Token": userSession?.accessToken });
//         const requestOptions = {
//             method,
//             headers: myHeaders,
//             body: body ? body : null,
//         };

//         const response = await fetch(`${process.env.REACT_APP_API_KEY}${fetchUrl}`, requestOptions);

//         if (!response.ok) {
//             const result = await response.json();
//             const errorMessage = result ? `Error: ${result.error.statusCode} ${result.message}` : `Error: ${response.status} ${response.statusText}`;
//             console.error(errorMessage);
//             // toastMessage((errMsg || errorMessage), "error")
//             return { success: false, error: errorMessage };
//         }
//         const result = await response.json();
//         return { success: true, data: result?.data ?? [] };
//     } catch (error) {
//         console.error("Fetch function error:", error);
//         return { success: false, data: null, message: error.message };
//         // toastMessage((errMsg || "Network or server error"), "error")
//         // return { success: false, error: error.message };
//     }
// };

// apiUtils.js or wherever you're making API calls
import axiosInstance from "../api/axiosInstance";

export const fetchFun = async (url, method = "GET", body = null, errMsg = "An error occurred") => {
    try {
        const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

        const config = {
            method,
            url,
            withCredentials: true, // ensures cookies like access_token and refresh_token are sent
            headers: {},
        };

        if (body) {
            config.data = body;

            if (!isFormData) {
                config.headers["Content-Type"] = "application/json";
            }
            // If body is FormData, don't set Content-Type — browser/axios will handle it
        }

        const response = await axiosInstance(config);

        return {
            success: true,
            data: response.data?.data ?? response.data,
        };
    } catch (error) {
        console.error("API Error:", error);

        const message =
            error?.response?.data?.message ||
            error?.message ||
            errMsg;

        return {
            success: false,
            error: message,
            code: error?.response?.data?.code,
        };
    }
};
